/* unplugin-vue-components disabled */import { render } from "./ShopCreateForm.vue?vue&type=template&id=6553f37e&scoped=true"
import script from "./ShopCreateForm.vue?vue&type=script&lang=js"
export * from "./ShopCreateForm.vue?vue&type=script&lang=js"

import "./ShopCreateForm.vue?vue&type=style&index=0&id=6553f37e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6553f37e"]])

export default __exports__